import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalRef } from '@app/core/services/core-modal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export class CoreIframeConfig {
  url = ''
  closeMessage?:string
  validOrigin?:string[]
  callbackMessages?: (data:any,modalRef?:ModalRef) => void
}
@Component({
  selector: 'core-iframe',
  templateUrl: './core-iframe.component.html',
  styleUrls: ['./core-iframe.component.scss'],
  standalone: false,
})
export class CoreIframeComponent implements OnInit, OnDestroy {

  @Input()
  modalRef?: ModalRef;

  @Input()
  modalData = new CoreIframeConfig()

  safeLink?: SafeHtml

  constructor(
    private domSanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {
    if(this.modalData) this.safeLink = this.domSanitizer.bypassSecurityTrustResourceUrl(this.modalData.url)
    window.addEventListener('message', this.onMessage, true);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.onMessage);
  }
  private onMessage = (event: MessageEvent<any>) => {
    if(!!this.modalData.validOrigin) {
      let valid=false
      const origin = event.origin.toLowerCase()
      this.modalData
          .validOrigin
          .forEach(s=>{
            if(origin.endsWith(s.toLowerCase())) valid = true
          })
      if(!valid) return
    } else {
      if(event.origin !== window.location.origin) return
    }
    if(!event.data) return

    switch (event.data.action) {
      case 'close':
        const id = event.data.result?.ID ?? 0
        window.removeEventListener('message', this.onMessage)
        if(this.modalRef) this.modalRef.close(id)
        break;
      default:
        if(!!this.modalData.callbackMessages) {
          this.modalData.callbackMessages(event, this.modalRef)
        }
        break;
    }
  }

  onCloseModalClick() {
    if(this.modalRef) this.modalRef.close()
  }
}
